import { createContext, useContext } from 'react'
import type { IStore } from '../store/store';
import type { IUIStore } from '../store/uistore'

interface IStoreContext {
  store?: IStore
  uistore?: IUIStore
}
export const StoreContext = createContext({} as IStoreContext)

export const useStore = (): IStore => {
  return useContext(StoreContext).store;
}

export const useUiStore = (): IUIStore => {
  return useContext(StoreContext).uistore;
}
